<template>
<div class="contentBox myOrderListPage">
    <div class="pageTitle">
        <h1>我的订单</h1>
        <div class="searchBox">
            <input type="text" class="search" @focus="focusInput" @blur="inputBlur" v-model="searchVal" />
            <div :class="[searchFocus ? 'focus' : '', 'searchBtn searchIcon']"></div>
            <button class="buyBtn" @click="jumpPage('/finance/recharge')">
                <img src="../../../assets/currency.svg" alt />我要购买
            </button>
        </div>
    </div>
    <div class="myOrderListWrap">
        <el-table :data="orders" style="width: 100%" header-row-class-name="tableHeader noBorderHeader">
            <el-table-column prop="paySerial" label="订单标号" align="left"></el-table-column>
            <el-table-column prop="packageTitle" label="套餐" align="left"></el-table-column>
            <el-table-column prop="totalPrice" label="价格" align="right"></el-table-column>
            <el-table-column prop="orderTime" label="时间" align="left"></el-table-column>
            <el-table-column prop="statusName" label="状态" align="center" width="100"></el-table-column>
            <el-table-column prop="date" label="操作" align="center" width="160">
                <template slot-scope="scope">
                    <button class="actionBtn" v-if="scope.row.status === 1 " @click="bill(scope.row)">
                        申请开票
                    </button>
                    <button class="actionBtn" v-if="scope.row.status === 0 || scope.row.status === 2" @click="goPay(scope.row)">
                        去支付
                    </button>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <div class="paginationBox" v-if="pageCount > 1">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="currentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
    </div>
    <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%">
        <span>{{dlgMessage}}，现在去设置吗？</span>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="goSettings">确 定</el-button>
  </span>
    </el-dialog>
</div>
</template>

<script>
    import common from '../../../common.vue';

    const ORDER_STATUS_MAPPER = {
        0: "未支付",
        1: "支付成功",
        2: "支付失败",
        3: "申请开票",
        4: "已开票"
    };
    const PREPARE_BILL_MAPPER = {
        1: "检查成功",
        2: "开票信息不完整，请到【账号设置】填写完整",
        3: "邮寄信息不完整，请到【账号设置】填写完整"
    };
    const APPLY_BILL_MAPPER = {
        0: '已申请开票，请等待管理员处理',
        1: "该订单已申请开票，请等待处理",
        2: "该订单发票已经开具",
        3: "订单尚未支付",
        4: "无效订单",
        9: "访问被拒绝"
    };


    export default {
        name: "MyOrder",
        data() {
            return {
                dialogVisible: false,
                dlgMessage: '',
                searchVal: '',
                searchFocus: false,
                pageIndex: 1,
                pageSize: 20,
                pageCount: 0,
                totalCount: 0,
                orders: [],
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            handleAction(index, row, path) {
                /*console.log(index, row);*/
                this.$router.push(`${path}`);
            },
            focusInput() {
                this.searchFocus = true;
            },
            inputBlur() {
                this.searchFocus = false;
            },
            setCurrentTotal() {
                this.currentTotal = this.myPurchaseHistory.length;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                console.log(`当前页: ${val}`);
            },
            /**
             * 去支付
             */
            goPay(order){
                this.$router.push({
                    path: '/finance/pay',
                    name: 'Pay',
                    params: { oid: order.orderId }
                });
            },
            /**
             * 获取订单
             * @param pageIndex
             */
            getOrders(pageIndex) {
                let _this = this, index = pageIndex || 1;

                _this.orders = [];
                _this.$axios.post(common._BASE_ + '/order/orderList',
                    this.$qs.stringify({pageNo: index, pageSize: _this.pageSize})).then(function (res) {
                    let r = res.data;
                    _this.pageIndex = index;
                    if (r && r.data) {
                        _this.dealOrder(r.data);
                    }
                    _this.totalCount = r.count;
                    _this.pageCount = Math.ceil(r.count / _this.pageSize);
                });
            },
            /**
             * 格式化订单
             * @param orders 订单列表
             */
            dealOrder(orders){
                let _this = this;
                (orders || []).forEach(function(order){
                    order.statusName = ORDER_STATUS_MAPPER[order.status];
                    _this.orders.push(order);
                });
            },
            bill(order){
                if(!order){ return; }
                let _this = this;

                _this.$axios.post(common._BASE_ + '/sponsor/prepareBill').then(function (res) {
                    let r = res.data;
                    if (r && r.code > 0) {
                        if(r.code === 1){
                            _this.doBill(order);
                        }else{
                            _this.dlgMessage = PREPARE_BILL_MAPPER[r.code];
                            _this.dialogVisible = true;
                        }
                    }else{
                        _this.jumpPage('/login');
                    }

                });
            },
            /**
             * 真的开票
             * @param order
             */
            doBill(order){
                console.info(order);
                if(!order){ return; }
                let _this = this;

                _this.$axios.post(common._BASE_ + '/order/applyBill',
                    this.$qs.stringify({orderId: order.orderId})).then(function (res) {
                    let r = res.data;
                    if (r && r.code >= 0) {
                        if(r.code === 0){
                            order.status = 3;
                            _this.$notify({
                                title: '发票申请已发生',
                                message: '工作人员将在5个工作日内邮寄发票',
                                type: 'success'
                            });
                        }else{
                            _this.$notify({
                                title: '失败',
                                message: APPLY_BILL_MAPPER[r.code],
                                type: 'error'
                            });
                        }
                    }else{
                        _this.jumpPage('/login');
                    }

                });
            },
            /**
             * 跳到设置页
             */
            goSettings(){
                this.jumpPage('/account/info');
            }
        },

        mounted() {
            this.getOrders(1);
        },
    };
</script> 

<style lang="less">
.myOrderListPage {
    .pageTitle {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchBox {
            position: relative;
            display: flex;

            .search {
                width: 437px;
                height: 40px;
                border: solid 1px #e8e8e8;
                background: #fff;
                border-radius: 6px;
                padding-left: 12px;
            }

            .search:focus {
                border: 1px solid #306ff6;
            }
        }

        .buyBtn {
            width: 137px;
            height: 40px;
            background: #076eff;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            margin-left: 10px;

            img {
                margin-right: 6px;
            }
        }
    }

    // .myOrderListWrap{
    //     height:980px;
    // }

    .actionBtn {
        width: 80px;
        height: 25px;
        background: #ffffff;
        border: 1px solid #c1c5c5;
        border-radius: 4px;
    }

    .actionBtn:hover {
        width: 80px;
        height: 25px;
        background: #306ff6;
        border-radius: 4px;
        color: #fff;
    }
}

.el-table__body-wrapper.is-scrolling-none,
.el-table__header {
    border: solid 1px #ebeef5;
}

.el-table__header {
    border-bottom: none;
}

.el-table__body-wrapper.is-scrolling-none {
    border-top: none;
}

.el-table .el-table__cell.is-center>.cell {
    padding: 0;
}
</style>